import * as tslib_1 from "tslib";
import { of } from 'rxjs';
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { MaklerPaket } from './Model/MaklerPaket';
import { environment } from '../../../../environments/environment';
var PaketService = /** @class */ (function (_super) {
    tslib_1.__extends(PaketService, _super);
    function PaketService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: 'makpak/findMaklerPakete'
        }) || this;
        _this.http = http;
        return _this;
    }
    // getPackages(user: string, vtnr: string): Observable<MaklerPaket[]> {
    //   let urlParam = `${user +  "/" + vtnr}`;
    //   console.log("Url param maklerPaketStatusInput: "+urlParam);
    //   return super.get(urlParam).map((res:MaklerPaket[]) => {
    //     return res;
    //   });
    // }
    PaketService.prototype.getPackages = function () {
        var packages = [
            new MaklerPaket("1", "eins", "test", "test", "test", "", "", []),
        ];
        return of(packages);
    };
    return PaketService;
}(RESTService));
export { PaketService };
